export const GALLERY = [
  '/images/hero_retouched_v3_0.png',
  'https://customer-assets-4nw71qhi.emergentagent.net/job_countryside-getaway-3/artifacts/yrxm6vim_IMG-20260801-WA0011.jpg',
  'https://customer-assets-jai6qajn.emergentagent.net/job_obachrural/artifacts/h3hixect_file_00000000a47081f4b261466ffffb9d6a.png',
  'https://customer-assets-4nw71qhi.emergentagent.net/job_countryside-getaway-3/artifacts/9hti98m4_file_00000000180881f492e70b724115d36a.png',
  'https://customer-assets-4nw71qhi.emergentagent.net/job_countryside-getaway-3/artifacts/sddjuwry_file_00000000b37481f6aa1b7a955de1593d.png',
  'https://customer-assets-4nw71qhi.emergentagent.net/job_countryside-getaway-3/artifacts/oj7pc74j_IMG-20260801-WA0013.jpg',
  'https://customer-assets-4nw71qhi.emergentagent.net/job_countryside-getaway-3/artifacts/dsiop0za_IMG-20250301-WA0037.webp',
  'https://customer-assets-4nw71qhi.emergentagent.net/job_countryside-getaway-3/artifacts/in14m6bq_IMG-20240115-WA0020.webp',
  'https://customer-assets-4nw71qhi.emergentagent.net/job_countryside-getaway-3/artifacts/rmyjy0tx_IMG-20260801-WA0014.webp',
  'https://customer-assets-4nw71qhi.emergentagent.net/job_countryside-getaway-3/artifacts/wqpxdz91_IMG_20241025_082534.webp',
];

export const HERO_IMAGE = GALLERY[0];
export const VILLAGE_IMAGE = 'https://customer-assets-jai6qajn.emergentagent.net/job_obachrural/artifacts/3bhf3ycu_IMG_20260803_183105.webp';

export const CONTACT = {
  phone: '+34 617 195 697',
  phoneRaw: '+34617195697',
  whatsapp: '34617195697',
  email: 'obachrural@gmail.com',
  address: 'La Pobla de Cérvoles, Les Garrigues, Catalunya',
  area: 'Les Garrigues · Lleida',
  mapsUrl: 'https://www.google.com/maps/search/?api=1&query=La+Pobla+de+C%C3%A9rvoles',
  mapsEmbed: 'https://www.google.com/maps?q=La+Pobla+de+C%C3%A9rvoles,+Lleida&hl=ca&z=11&output=embed',
};

export const AMENITY_KEYS = ['wifi','fireplace','kitchen','garden','parking','bbq'];
export const EXPERIENCE_KEYS = ['routes','stone','stars','ermita','reservoir','sentits','oil','trenches','mushrooms'];
export const VILLAGE_SERVICE_KEYS = ['bars','shops','bakery','restaurants','pools','doctor'];
